import { Component, EventEmitter, Input, OnInit, Output, inject, ChangeDetectionStrategy } from "@angular/core";
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from "@angular/material/dialog";
import { BehaviorSubject } from "rxjs";
import { first } from "rxjs/operators";

import { LorenEntityFormModel } from "../../../loren-entity-form-card/interfaces/loren-entity-form-model.interface.ts";
import { LorenFieldTypes } from "../../../loren-entity-form-card/enums/loren-field-types.enum";
import { LorenModalData } from "../../../loren-dialog/interfaces/loren-modal-data.interface";
import { LorenDialogComponent } from "../../../loren-dialog/components/loren-dialog/loren-dialog.component";

@Component({
    selector: "loren-location-filter-dialog",
    template: ``,
    styleUrls: ["./loren-location-filter-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenLocationFilterDialogComponent implements OnInit {
  private dialog = inject(MatDialog);

  @Input() lastSelectedDistance: number;
  @Output() finishSelection = new EventEmitter<number>();
  @Output() cancelSelection = new EventEmitter<void>();

  private reloadSubject = new BehaviorSubject<null>(null);
  private dialogConfig: MatDialogConfig<LorenModalData>;
  private dialogRef: MatDialogRef<LorenDialogComponent>;
  ngOnInit(): void {
    const formModel: LorenEntityFormModel = {
      formFields: [
        {
          name: "distanceFilter",
          label: "operations.choose_location_distance_sub_title",
          placeholder: "operations.distance_filter_placeholder",
          formControlType: LorenFieldTypes.SELECT,
          options: [5, 10, 20, 30, 40, 50, 100, 500, 1000, 10000, 100000].map(
            (x) => ({ key: `${x}`, value: x })
          ),
          value: this.lastSelectedDistance ? this.lastSelectedDistance : 100,
        },
      ],
      formName: "",
      reloadForm: this.reloadSubject,
    };

    const entitiesListDialog: LorenModalData = {
      form: formModel,
      modalAcceptBtnLabel: "operations.confirm",
      modalCloseBtnLabel: `operations.cancel`,
      title: `operations.choose_location_distance_title`,
      modalSubTitle: ``,
    };

    this.prepareDialog(entitiesListDialog)
      .pipe(first())
      .subscribe((result) => {
        if (!result) {
          this.cancelSelection.emit();
          return;
        }

        this.finishSelection.emit(formModel.formFields[0].value);
      });
  }

  private prepareDialog(modalData: LorenModalData) {
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.data = modalData;
    this.dialogConfig.width = "600px";
    this.dialogConfig.hasBackdrop = false;

    this.dialogRef = this.dialog.open(LorenDialogComponent, this.dialogConfig);

    return this.dialogRef.afterClosed();
  }
}
